import { useState } from 'react'
import { useAddRegion, useRemoveRegion, useToggleRegion } from '@/hooks/useAdminActions'
import { AdminError } from './AdminError'
import type { Region } from '@/types/database'

interface CoverageEditorProps {
  clientId: string
  regions: Region[]
}

export function CoverageEditor({ clientId, regions }: CoverageEditorProps) {
  const [place, setPlace] = useState('')
  const add = useAddRegion()
  const toggle = useToggleRegion()
  const remove = useRemoveRegion()

  function submit(e: React.FormEvent) {
    e.preventDefault()
    if (!place.trim() || add.isPending) return
    add.mutate({ clientId, name: place }, { onSuccess: () => setPlace('') })
  }

  return (
    <div className="admin-section">
      <h2 className="admin-section-title">Coverage Area</h2>

      <form className="admin-inline-form" onSubmit={submit}>
        <input
          className="admin-input"
          value={place}
          onChange={(e) => setPlace(e.target.value)}
          placeholder="Add a place…"
        />
        <button className="btn-primary btn--amber" type="submit" disabled={!place.trim() || add.isPending}>
          {add.isPending ? 'Adding…' : 'Add'}
        </button>
      </form>

      <AdminError error={add.error ?? toggle.error ?? remove.error} />

      {regions.length === 0 ? (
        <p className="admin-empty-hint">No coverage areas yet.</p>
      ) : (
        <div className="admin-place-list">
          {regions.map((tag) => (
            <div key={tag.id} className={`admin-place-row ${tag.active ? '' : 'admin-place-row--inactive'}`}>
              <span className={`place-dot ${tag.active ? 'place-dot--active' : ''}`} />
              <span>{tag.name}</span>
              <div className="admin-row-actions">
                <button
                  className="admin-link-btn"
                  onClick={() => toggle.mutate({ id: tag.id, active: !tag.active, clientId })}
                  disabled={toggle.isPending}
                >
                  {tag.active ? 'Deactivate' : 'Activate'}
                </button>
                <button
                  className="admin-link-btn admin-link-btn--danger"
                  onClick={() => remove.mutate({ id: tag.id, clientId })}
                  disabled={remove.isPending}
                >
                  Remove
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
